module.exports = __webpack_public_path__ + "img/bnb.5efc3573.svg";